var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuperSentinel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.25L16.5 17.25V23.25C16.5 28.5 20.25 32.25 24 33.75C27.75 32.25 31.5 28.5 31.5 23.25V17.25L24 14.25Z",
    stroke: "#1B2559",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26.25C25.6569 26.25 27 24.9069 27 23.25C27 21.5931 25.6569 20.25 24 20.25C22.3431 20.25 21 21.5931 21 23.25C21 24.9069 22.3431 26.25 24 26.25Z",
    stroke: "#1B2559",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperSentinel);
export default __webpack_public_path__ + "static/media/Super-Sentinel.2396115847d86c862da0ad3d837d1656.svg";
export { ForwardRef as ReactComponent };